import type { ChartData } from 'chart.js'

import { DoughnutChart } from '@/components/charts/doughnut-chart.tsx'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.tsx'

import { EmptyChartData } from './empty-chart-data.tsx'
import type { ToggleChartOptions } from './types'

interface Props {
  data?: ChartData<'doughnut', number[], unknown>
  isFetching: boolean
  title: string
  totalValue: string | undefined
  toggleOptions?: ToggleChartOptions
}

export const DoughnutChartCard = ({
  data,
  isFetching,
  title,
  totalValue = '0',
  toggleOptions,
}: Props) => {
  return (
    <Card className="flex flex-col justify-between">
      <CardHeader>
        <CardTitle className="text-xl font-semibold leading-none text-text-default">
          <div className="flex w-full justify-between">{totalValue || 0}</div>
        </CardTitle>
        <CardDescription className="text-text-sub">{title}</CardDescription>
      </CardHeader>
      <CardContent>
        {isFetching || !data ? (
          <EmptyChartData isFetching={isFetching} />
        ) : (
          <div className="h-72 content-center justify-center p-6">
            <DoughnutChart
              data={data}
              toggleOptions={toggleOptions}
            />
          </div>
        )}
      </CardContent>
    </Card>
  )
}
